import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

import shareIcon from "../../../assets/images/share.png";
import closeIcon from "../../../assets/images/close.png";


export default function Sezione3popup3({ isOpen, onClose }) {
  const overlayRef = useRef(null);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose?.();
    if (isOpen) {
      document.body.classList.add("overflow-hidden");
      window.addEventListener("keydown", onKey);
    }
    return () => {
      document.body.classList.remove("overflow-hidden");
      window.removeEventListener("keydown", onKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const onShare = (popupId) => {
    const url = new URL(window.location.href);
    url.searchParams.set("popup", popupId);

    if (navigator.share) {
      navigator
        .share({ title: "Perimetro di Consolidamento", url: url.toString() })
        .catch(() => {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url.toString()).catch(() => {});
    }
  };

  return createPortal(
    <div
      ref={overlayRef}
      className="fixed inset-0 z-[999] bg-black/50 backdrop-blur-[2px] flex items-center justify-center p-3 md:p-6"
      onMouseDown={(e) => {
        if (e.target === overlayRef.current) onClose?.();
      }}
      role="dialog"
      aria-modal="true"
      aria-label="Perimetro di consolidamento"
    >
      <div
        className="
          relative w-full md:w-[1280px] bg-white shadow-2xl
          max-h-[90vh] overflow-y-auto overscroll-contain
        "
        style={{ background: "#E7E3DF", WebkitOverflowScrolling: "touch" }}
      >
        {/* Azioni in alto */}
        <div className="sticky top-3 z-10 flex items-center gap-2 justify-end pr-3">
          <button
            onClick={() => onShare("Sezione3popup3")}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full text-[#0E3761] bg-white/90 border border-[#0E3761]/30 hover:bg-white transition"
            title="Condividi"
            aria-label="Condividi"
          >
            <img src={shareIcon} alt="" className="h-4 w-4" />
          </button>
          <button
            onClick={onClose}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full text-[#0E3761] bg-white/90 border border-[#0E3761]/30 hover:bg-white transition"
            title="Chiudi"
            aria-label="Chiudi"
          >
            <img src={closeIcon} alt="Chiudi" className="h-4 w-4" />
          </button>
        </div>

        {/* Contenuto */}
        <div className="p-8 text-[16px] md:text-[26px]">
            <p>
                <b>Nata nel 1828,</b> Reale Mutua <b>è la più grande Compagnia italiana in forma di mutua ed è la Capogruppo di Reale Group.</b>
            </p>
            <p>
                La missione della Società è strettamente legata alla sua <b>natura mutualistica</b>: porre sempre i Soci/Assicurati al centro delle proprie attenzioni, garantendo loro qualità e certezza delle prestazioni.          </p>
            <p>
                Nella mutua assicuratrice <b>il Cliente che sottoscrive una polizza diventa anche Socio</b>. La forma mutualistica prevede la possibilità di riconoscere <b>“vantaggi mutualistici”</b> ai Soci/Assicurati, distribuiti in una duplice modalità: 
                <ul className="list-disc pl-6 md:pl-8 pt-2">
                  <li>come vantaggi <b>immediati</b>, nella forma di miglioramenti delle prestazioni e/o riduzioni di premi <b>(benefici di mutualità);</b></li>
                  <li>come vantaggi <b>differiti</b>, nella forma di <b>Ristorni</b> (riconoscimento di parte dell’avanzo di gestione realizzato dalla Compagnia).</li>
                </ul>
            </p>
            <p>
              La vicinanza ai propri Soci/Assicurati si manifesta anche con iniziative di Responsabilità Sociale.
            </p>
            <p>
                <b>La sostenibilità è, infatti, un valore fondamentale per Reale Mutua,</b> che da sempre adotta una gestione etica e trasparente dei propri affari, sostiene lo sviluppo di attività culturali e si impegna a favore dell’ambiente, della tutela sociale, delle persone e della comunità. Rientra in questo contesto la <b>scelta, nel 2022, di acquisire la qualifica di Società Benefit.</b>
            </p>
        </div>

        </div>
    </div>,
    document.body
  );
}
